module.exports = __webpack_public_path__ + "static/offre_image_mobile-3e70424dd840b4d9b3dd7f07666f1604.jpg";